"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AssetPortalActions = _interopRequireDefault(require("../../AssetPortalActions"));
var _VersionAgnosticInformation = _interopRequireDefault(require("../../VersionAgnosticInformation"));
var _MinorVersionProperties = _interopRequireDefault(require("../../MinorVersionProperties"));
var _BackToAssets = _interopRequireDefault(require("../BackToAssets"));
var _CollapseButton = _interopRequireDefault(require("./CollapseButton"));
var styles = {
  "asset-metadata": "AssetMetadata__asset-metadata__FR6Rb",
  "assetMetadata": "AssetMetadata__asset-metadata__FR6Rb",
  "expanded-asset-metadata": "AssetMetadata__expanded-asset-metadata__2hM1A",
  "expandedAssetMetadata": "AssetMetadata__expanded-asset-metadata__2hM1A",
  "column-asset-metadata": "AssetMetadata__column-asset-metadata__35gIZ",
  "columnAssetMetadata": "AssetMetadata__column-asset-metadata__35gIZ",
  "collapsed-asset-metadata": "AssetMetadata__collapsed-asset-metadata__ikOgJ",
  "collapsedAssetMetadata": "AssetMetadata__collapsed-asset-metadata__ikOgJ",
  "header": "AssetMetadata__header__3ZIcV",
  "asset-metadata-container": "AssetMetadata__asset-metadata-container__13g4r",
  "assetMetadataContainer": "AssetMetadata__asset-metadata-container__13g4r",
  "minor-version": "AssetMetadata__minor-version__1-00E",
  "minorVersion": "AssetMetadata__minor-version__1-00E",
  "change-view": "AssetMetadata__change-view__2XOII",
  "changeView": "AssetMetadata__change-view__2XOII",
  "hr": "AssetMetadata__hr__38xc1",
  "header-margin": "AssetMetadata__header-margin__297tX",
  "headerMargin": "AssetMetadata__header-margin__297tX",
  "header-info": "AssetMetadata__header-info__3uTjl",
  "headerInfo": "AssetMetadata__header-info__3uTjl",
  "header-row": "AssetMetadata__header-row__dTOt0",
  "headerRow": "AssetMetadata__header-row__dTOt0",
  "edit-buttons": "AssetMetadata__edit-buttons__XdeWi",
  "editButtons": "AssetMetadata__edit-buttons__XdeWi"
}; 
require('../AssetMetadata.css');
var ExpandedAssetMetadata = function ExpandedAssetMetadata(_ref) {
  var isLoading = _ref.isLoading,
    onEditField = _ref.onEditField,
    asset = _ref.asset,
    onToggleView = _ref.onToggleView,
    renderEditButtons = _ref.renderEditButtons,
    isEditing = _ref.isEditing,
    isToggleViewButtonFocused = _ref.isToggleViewButtonFocused;
  var name = asset.name,
    icon = asset.icon,
    description = asset.description,
    type = asset.type,
    organization = asset.organization,
    contactName = asset.contactName,
    contactEmail = asset.contactEmail,
    modifiedAt = asset.modifiedAt;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.expandedAssetMetadata
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.columnAssetMetadata
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/_react.default.createElement(_BackToAssets.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.assetMetadataContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles.headerInfo, styles.headerMargin)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.headerRow
  }, /*#__PURE__*/_react.default.createElement(_VersionAgnosticInformation.default, {
    isDisabled: isLoading,
    isEditing: isEditing,
    onEditField: onEditField,
    isExpanded: true,
    icon: icon,
    isCertified: false,
    minorVersionModifiedAt: modifiedAt,
    contactName: contactName,
    contactEmail: contactEmail,
    description: description,
    name: name,
    organization: organization.name,
    type: type
  }), renderEditButtons()), /*#__PURE__*/_react.default.createElement(_AssetPortalActions.default, {
    asset: asset
  })), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_MinorVersionProperties.default, {
    asset: asset
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.changeView
  }, /*#__PURE__*/_react.default.createElement(_CollapseButton.default, {
    isDisabled: isEditing || isLoading,
    onClick: onToggleView,
    isFocused: isToggleViewButtonFocused
  })));
};
var _default = exports.default = ExpandedAssetMetadata;
//# sourceMappingURL=ExpandedAssetMetadata.js.map